const favoritesFn = {
    isFavorite: (adID) => {
        const favItems = JSON.parse(localStorage.getItem("fav_ads")) || [];
        return favItems.find((item) => {
            return item.toString() === adID;
        });
    },
    markFavoriteHearts: () => {
        document.querySelectorAll('.fav-ico').forEach((element) => {
            let el = element.closest('[data-id]');
            if (favoritesFn.isFavorite(el.getAttribute('data-id'))) el.classList.add('isfav');
        });
    }
};
export default favoritesFn;